// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MarketTypeFromJSON, MarketTypeToJSON, PostMarketAllocationFromJSON, PostMarketAllocationToJSON, } from './';
export function PostMarketRequestFromJSON(json) {
    return {
        'name': json['name'],
        'currency': json['currency'],
        'description': json['description'],
        'marketType': MarketTypeFromJSON(json['marketType']),
        'vintages': !exists(json, 'vintages') ? undefined : json['vintages'],
        'strategies': !exists(json, 'strategies') ? undefined : json['strategies'],
        'geographies': !exists(json, 'geographies') ? undefined : json['geographies'],
        'assetClasses': !exists(json, 'assetClasses') ? undefined : json['assetClasses'],
        'currencies': !exists(json, 'currencies') ? undefined : json['currencies'],
        'allocations': !exists(json, 'allocations') ? undefined : json['allocations'].map(PostMarketAllocationFromJSON),
        'source': json['source'],
    };
}
export function PostMarketRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'name': value.name,
        'currency': value.currency,
        'description': value.description,
        'marketType': MarketTypeToJSON(value.marketType),
        'vintages': value.vintages,
        'strategies': value.strategies,
        'geographies': value.geographies,
        'assetClasses': value.assetClasses,
        'currencies': value.currencies,
        'allocations': value.allocations === undefined ? undefined : value.allocations.map(PostMarketAllocationToJSON),
        'source': value.source,
    };
}
/**
* @export
* @enum {string}
*/
export var PostMarketRequestSourceEnum;
(function (PostMarketRequestSourceEnum) {
    PostMarketRequestSourceEnum["InsightResearch"] = "InsightResearch";
    PostMarketRequestSourceEnum["PreqinIndex"] = "PreqinIndex";
})(PostMarketRequestSourceEnum || (PostMarketRequestSourceEnum = {}));
